import { axiosMock } from '../client';
import { generatePaginatedRandomTeamMemberList } from '../../mocks/team';
import { PaginatedArgs } from '@dynamika-shared/types/general';
import { TeamMembersArgs } from '@api/teamMembers';


export const fetchTeamMemberListMock = async (args?: PaginatedArgs & TeamMembersArgs) => {
  const data = generatePaginatedRandomTeamMemberList(50, {
    page: args?.page ?? 1,
    size: args?.size ?? 10,
  });
  const teamUrl = /\/clinical-trials\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/team-members/;
  axiosMock.onGet(teamUrl).reply(200, data);
  axiosMock.onGet(teamUrl, {
    params: {
      page: args?.page,
      size: args?.size,
    },
  });
};
